/* Mitras theme interactions — header, search, tabs, bundle, sticky bar,
   collection view toggle, article TOC, recently viewed.
   All handlers are defensive: every feature no-ops if its markup is absent. */
(function () {
  'use strict';

  var GBP = function (pence) {
    return '£' + (pence / 100).toFixed(2);
  };

  /* ---------------- Announcement bar dismiss ---------------- */
  /* Never hide the bar inside the theme editor: a merchant who dismissed it once
     would otherwise be unable to see or edit the section again. */
  var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);
  document.querySelectorAll('[data-m-announce]').forEach(function (bar) {
    var key = 'm-announce-dismissed:' + (bar.getAttribute('data-m-announce') || 'default');
    try {
      if (!inThemeEditor && window.localStorage.getItem(key)) bar.classList.add('is-dismissed');
    } catch (e) {
      /* private mode */
    }
    var close = bar.querySelector('[data-m-announce-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.classList.add('is-dismissed');
        try {
          window.localStorage.setItem(key, '1');
        } catch (e) {}
      });
    }
  });

  /* ---------------- Mega menu ---------------- */
  var header = document.querySelector('[data-m-header]');
  if (header) {
    var navItems = header.querySelectorAll('[data-m-nav-item]');
    var megas = header.querySelectorAll('[data-m-mega]');
    var closeTimer = null;

    var closeAll = function () {
      megas.forEach(function (m) {
        m.classList.remove('is-open');
      });
      navItems.forEach(function (i) {
        i.classList.remove('is-active');
      });
    };
    var openFor = function (item) {
      closeAll();
      var id = item.getAttribute('data-m-nav-item');
      var mega = header.querySelector('[data-m-mega="' + id + '"]');
      if (mega) {
        mega.classList.add('is-open');
        item.classList.add('is-active');
      }
    };

    navItems.forEach(function (item) {
      var hasMega = header.querySelector('[data-m-mega="' + item.getAttribute('data-m-nav-item') + '"]');
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        hasMega ? openFor(item) : closeAll();
      });
      var link = item.querySelector('a');
      if (link) {
        link.addEventListener('focus', function () {
          hasMega ? openFor(item) : closeAll();
        });
      }
      item.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(closeAll, 150);
      });
    });
    megas.forEach(function (mega) {
      mega.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });
      mega.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(closeAll, 150);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ---------------- Mobile search toggle ---------------- */
  var mobSearchBtn = document.querySelector('[data-m-mobsearch-toggle]');
  var mobSearch = document.querySelector('[data-m-mobsearch]');
  if (mobSearchBtn && mobSearch) {
    mobSearchBtn.addEventListener('click', function () {
      mobSearch.classList.toggle('is-open');
      if (mobSearch.classList.contains('is-open')) {
        var input = mobSearch.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------------- Mobile menu drawer with drill-down ---------------- */
  var drawer = document.querySelector('[data-m-drawer]');
  if (drawer) {
    var drawerTitle = drawer.querySelector('[data-m-drawer-title]');
    var rootTitle = drawerTitle ? drawerTitle.textContent : 'Menu';
    var showPanel = function (id) {
      drawer.querySelectorAll('[data-m-panel]').forEach(function (p) {
        p.classList.toggle('is-current', p.getAttribute('data-m-panel') === id);
      });
      var isRoot = id === 'root';
      drawer.classList.toggle('is-drilled', !isRoot);
      if (drawerTitle) {
        var current = drawer.querySelector('[data-m-panel="' + id + '"]');
        drawerTitle.textContent = isRoot ? rootTitle : (current && current.getAttribute('data-m-panel-title')) || rootTitle;
      }
    };
    document.querySelectorAll('[data-m-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        showPanel('root');
      });
    });
    drawer.querySelectorAll('[data-m-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      });
    });
    drawer.querySelectorAll('[data-m-drill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPanel(btn.getAttribute('data-m-drill'));
      });
    });
    var back = drawer.querySelector('[data-m-drawer-back]');
    if (back) {
      back.addEventListener('click', function () {
        showPanel('root');
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
    });
  }

  /* ---------------- Predictive search (suggest.json) ---------------- */
  document.querySelectorAll('[data-m-search]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var results = wrap.querySelector('[data-m-search-results]');
    if (!input || !results) return;
    var timer = null;
    var lastQuery = '';

    var close = function () {
      wrap.classList.remove('is-open');
    };
    var render = function (data, query) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        close();
        return;
      }
      var html = '<div class="m-search__results-head">Products</div>';
      products.forEach(function (p) {
        var pricePence = Math.round(parseFloat(p.price) * 100);
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url + '&width=88' : '';
        html +=
          '<a class="m-search__result" href="' + p.url + '">' +
          (img
            ? '<img class="m-search__result-img" src="' + img + '" alt="" loading="lazy" width="44" height="44">'
            : '<span class="m-search__result-img"></span>') +
          '<span class="m-search__result-main"><span class="m-search__result-title">' +
          p.title +
          '</span></span>' +
          (isNaN(pricePence)
            ? ''
            : '<span class="m-search__result-price"><span class="ex">' +
              GBP(pricePence) +
              ' <b>+VAT</b></span><span class="inc">' +
              GBP(Math.round(pricePence * 1.2)) +
              ' inc VAT</span></span>') +
          '</a>';
      });
      html +=
        '<a class="m-search__all" href="' +
        (window.routes && window.routes.cart_url ? '' : '') +
        '/search?q=' +
        encodeURIComponent(query) +
        '&type=product">See all results for &ldquo;' +
        query.replace(/</g, '&lt;') +
        '&rdquo;</a>';
      results.innerHTML = html;
      wrap.classList.add('is-open');
    };

    input.addEventListener('input', function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) {
        close();
        return;
      }
      timer = window.setTimeout(function () {
        lastQuery = q;
        fetch(
          '/search/suggest.json?q=' +
            encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last'
        )
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (q === lastQuery) render(data, q);
          })
          .catch(function () {});
      }, 250);
    });
    input.addEventListener('focus', function () {
      if (results.innerHTML.trim() && input.value.trim().length >= 2) wrap.classList.add('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  /* ---------------- Product tabs (tabs on desktop, accordion on mobile) ---------------- */
  var initTabs = function (root) {
    (root || document).querySelectorAll('[data-m-tabs]').forEach(function (tabs) {
      if (tabs.getAttribute('data-m-bound') === '1') return;
      tabs.setAttribute('data-m-bound', '1');
      var tabButtons = Array.prototype.slice.call(tabs.querySelectorAll('.m-tabs__tab'));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll('.m-tabs__panel'));
      var accHeads = Array.prototype.slice.call(tabs.querySelectorAll('.m-tabs__acc-head'));
      var isDesktop = function () {
        return window.matchMedia('(min-width: 750px)').matches;
      };

      var syncAccordion = function () {
        accHeads.forEach(function (h, i) {
          var open = panels[i] && panels[i].classList.contains('is-open');
          h.setAttribute('aria-expanded', open ? 'true' : 'false');
          var sign = h.querySelector('.sign');
          if (sign) sign.textContent = open ? '\u2212' : '+';
        });
      };

      var activate = function (n, focus) {
        tabButtons.forEach(function (b, i) {
          var on = i === n;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          /* Roving tabindex: only the selected tab is in the tab order. */
          if (on) b.removeAttribute('tabindex');
          else b.setAttribute('tabindex', '-1');
        });
        panels.forEach(function (p, i) {
          p.classList.toggle('is-open', i === n);
        });
        syncAccordion();
        if (focus && tabButtons[n]) tabButtons[n].focus();
      };

      tabButtons.forEach(function (b, i) {
        b.addEventListener('click', function () {
          activate(i);
        });
        b.addEventListener('keydown', function (e) {
          var last = tabButtons.length - 1;
          if (e.key === 'ArrowRight') activate(i === last ? 0 : i + 1, true);
          else if (e.key === 'ArrowLeft') activate(i === 0 ? last : i - 1, true);
          else if (e.key === 'Home') activate(0, true);
          else if (e.key === 'End') activate(last, true);
          else return;
          e.preventDefault();
        });
      });

      accHeads.forEach(function (h, i) {
        h.addEventListener('click', function () {
          if (isDesktop()) return;
          if (panels[i]) panels[i].classList.toggle('is-open');
          syncAccordion();
        });
      });

      // initial state: first tab open on desktop; first accordion open on mobile
      activate(0);
    });
  };
  initTabs(document);
  window.mitrasInitTabs = initTabs;

  /* ---------------- Bought together bundle ---------------- */
  document.querySelectorAll('[data-m-bundle]').forEach(function (bundle) {
    var items = bundle.querySelectorAll('[data-m-bundle-item]');
    var totalEx = bundle.querySelector('[data-m-bundle-total-ex]');
    var totalInc = bundle.querySelector('[data-m-bundle-total-inc]');
    var countLabel = bundle.querySelector('[data-m-bundle-count]');
    var addBtn = bundle.querySelector('[data-m-bundle-add]');

    var update = function () {
      var total = 0;
      var count = 0;
      items.forEach(function (item) {
        if (item.classList.contains('is-checked')) {
          total += parseInt(item.getAttribute('data-price'), 10) || 0;
          count += 1;
        }
      });
      if (totalEx) totalEx.textContent = GBP(total);
      if (totalInc) totalInc.textContent = GBP(Math.round(total * 1.2)) + ' inc VAT';
      if (countLabel) countLabel.textContent = 'Total for ' + count + (count === 1 ? ' item' : ' items');
      if (addBtn) addBtn.disabled = count === 0;
    };

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        if (item.hasAttribute('data-locked')) return;
        e.preventDefault();
        item.classList.toggle('is-checked');
        update();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var ids = [];
        items.forEach(function (item) {
          if (item.classList.contains('is-checked')) {
            var id = parseInt(item.getAttribute('data-variant-id'), 10);
            if (id) ids.push({ id: id, quantity: 1 });
          }
        });
        if (!ids.length) return;
        addBtn.disabled = true;
        var original = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: ids,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (parsed) {
            addBtn.textContent = 'Added to Basket';
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && parsed.sections) {
              cartDrawer.renderContents(parsed);
            }
            window.setTimeout(function () {
              addBtn.textContent = original;
              addBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            addBtn.textContent = original;
            addBtn.disabled = false;
          });
      });
    }
    update();
  });

  /* ---------------- Sticky add-to-basket bar (product page) ---------------- */
  var sticky = document.querySelector('[data-m-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var anchor = document.querySelector('.product-form__submit');
    if (anchor) {
      var stickyBtn0 = sticky.querySelector('[data-m-sticky-add]');
      var setStickyVisible = function (on) {
        sticky.classList.toggle('is-visible', on);
        /* Keep the accessibility tree and the tab order in step with visibility. */
        if (on) sticky.removeAttribute('aria-hidden');
        else sticky.setAttribute('aria-hidden', 'true');
        if (stickyBtn0) {
          if (on) stickyBtn0.removeAttribute('tabindex');
          else stickyBtn0.setAttribute('tabindex', '-1');
        }
      };
      setStickyVisible(false);
      var io = new IntersectionObserver(
        function (entries) {
          setStickyVisible(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        },
        { threshold: 0 }
      );
      io.observe(anchor);

      /* Keep the sticky price and CTA in step with the selected variant. */
      var syncSticky = function (variant) {
        if (!variant) return;
        var ex = sticky.querySelector('.m-sticky__price .ex');
        var inc = sticky.querySelector('.m-sticky__price .inc');
        if (ex) ex.textContent = GBP(variant.price);
        if (inc) inc.textContent = GBP(Math.round(variant.price * 1.2)) + ' inc VAT';
        if (stickyBtn0) {
          var soldOut = variant.available === false;
          stickyBtn0.disabled = soldOut;
          stickyBtn0.textContent = soldOut ? 'Out of Stock' : 'Add to Basket';
        }
        var meta = document.querySelector('[data-m-product-meta]');
        if (meta) meta.setAttribute('data-price', variant.price);
      };
      /* constants.js declares PUB_SUB_EVENTS with `const`, so it is a global lexical
         binding and NOT a property of window — it must be probed with typeof. */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data && event.data.variant) syncSticky(event.data.variant);
        });
      }

      var stickyBtn = stickyBtn0;
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var mainSubmit = document.querySelector('.product-form__submit');
          if (mainSubmit && !mainSubmit.disabled) {
            mainSubmit.click();
          } else {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }
  }

  /* ---------------- Collection grid/list view toggle ---------------- */
  var viewToggle = document.querySelector('[data-m-viewtoggle]');
  if (viewToggle) {
    var shell = document.querySelector('[data-m-collection]');
    var buttons = viewToggle.querySelectorAll('button');
    var setView = function (view, persist) {
      if (shell) shell.classList.toggle('m-list-view', view === 'list');
      buttons.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-view') === view);
      });
      if (persist) {
        try {
          window.localStorage.setItem('m-collection-view', view);
        } catch (e) {}
      }
    };
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        setView(b.getAttribute('data-view'), true);
      });
    });
    var saved = null;
    try {
      saved = window.localStorage.getItem('m-collection-view');
    } catch (e) {}
    setView(saved === 'list' ? 'list' : 'grid', false);
  }

  /* ---------------- Article table of contents + scroll-spy ---------------- */
  var articleBody = document.querySelector('[data-m-article-body]');
  var tocList = document.querySelector('[data-m-toc]');
  if (articleBody && tocList) {
    var headings = articleBody.querySelectorAll('h2');
    if (headings.length >= 2) {
      var frag = document.createDocumentFragment();
      headings.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        frag.appendChild(li);
      });
      tocList.appendChild(frag);
      var tocLinks = tocList.querySelectorAll('a');
      var spy = function () {
        var active = 0;
        headings.forEach(function (h, i) {
          if (h.getBoundingClientRect().top < 160) active = i;
        });
        tocLinks.forEach(function (a, i) {
          a.classList.toggle('is-active', i === active);
        });
      };
      window.addEventListener('scroll', spy, { passive: true });
      spy();
    } else {
      var aside = tocList.closest('.m-aside-card');
      if (aside) aside.style.display = 'none';
    }
  }

  /* ---------------- Recently viewed ---------------- */
  var RV_KEY = 'm-recently-viewed';
  var rvData = [];
  try {
    rvData = JSON.parse(window.localStorage.getItem(RV_KEY) || '[]');
  } catch (e) {}

  var currentProduct = document.querySelector('[data-m-product-meta]');
  if (currentProduct) {
    var meta = {
      handle: currentProduct.getAttribute('data-handle'),
      title: currentProduct.getAttribute('data-title'),
      price: parseInt(currentProduct.getAttribute('data-price'), 10) || 0,
      image: currentProduct.getAttribute('data-image') || '',
      url: currentProduct.getAttribute('data-url'),
    };
    if (meta.handle) {
      rvData = rvData.filter(function (p) {
        return p.handle !== meta.handle;
      });
      rvData.unshift(meta);
      rvData = rvData.slice(0, 8);
      try {
        window.localStorage.setItem(RV_KEY, JSON.stringify(rvData));
      } catch (e) {}
    }
  }

  var rvContainer = document.querySelector('[data-m-recent]');
  if (rvContainer) {
    var currentHandle = currentProduct ? currentProduct.getAttribute('data-handle') : null;
    var list = rvData
      .filter(function (p) {
        return p.handle !== currentHandle;
      })
      .slice(0, 4);
    if (!list.length) {
      var recentWrap = rvContainer.closest('[data-m-recent-wrap]');
      if (recentWrap) recentWrap.style.display = 'none';
    } else {
      list.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'm-recent__item';
        a.href = p.url;
        a.innerHTML =
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="44" height="44">' : '') +
          '<span><strong></strong><span class="m-recent__price"></span></span>';
        a.querySelector('strong').textContent = p.title;
        a.querySelector('.m-recent__price').textContent = p.price ? GBP(p.price) + ' +VAT' : '';
        rvContainer.appendChild(a);
      });
    }
  }

  /* ---------------- Mobile basket button (sync count + open drawer) ---------------- */
  var mobBasket = document.querySelector('[data-m-basket-mob]');
  var deskBasket = document.getElementById('cart-icon-bubble');
  if (mobBasket) {
    mobBasket.addEventListener('click', function (e) {
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
        e.preventDefault();
        cartDrawerEl.open(mobBasket);
      }
    });
    if (deskBasket && 'MutationObserver' in window) {
      var syncCount = function () {
        var chip = deskBasket.querySelector('.m-basket-count');
        var mobChip = mobBasket.querySelector('[data-m-basket-mob-count]');
        if (!mobChip) return;
        if (chip && chip.textContent.trim()) {
          mobChip.textContent = chip.textContent.trim();
          mobChip.hidden = false;
        } else {
          mobChip.hidden = true;
        }
      };
      new MutationObserver(syncCount).observe(deskBasket, { childList: true, subtree: true });
      syncCount();
    }
  }

  /* ---------------- Home selector (two questions) ---------------- */
  /* Every [data-m-selector] on the page is wired up, not just the first: the box
     finder can run inside the hero panel and as a standalone section at once, and
     the theme editor re-renders one section at a time. */
  var initSelectors = function (root) {
    (root || document).querySelectorAll('[data-m-selector]').forEach(function (selector) {
      if (selector.getAttribute('data-m-selector-ready') === '1') return;
      selector.setAttribute('data-m-selector-ready', '1');

      var meterOpts = selector.querySelectorAll('[data-m-meter]');
      var mountOpts = selector.querySelectorAll('[data-m-mount]');
      var step2 = selector.querySelector('[data-m-step2]');
      var resultLabel = selector.querySelector('[data-m-selector-label]');
      var resultCta = selector.querySelector('[data-m-selector-cta]');
      var state = { meter: null, mount: null };

      var refresh = function () {
        meterOpts.forEach(function (o) {
          o.classList.toggle('is-selected', o.getAttribute('data-m-meter') === state.meter);
        });
        mountOpts.forEach(function (o) {
          o.classList.toggle('is-selected', o.getAttribute('data-m-mount') === state.mount);
        });
        if (step2) step2.classList.toggle('m-selector__step--waiting', !state.meter);
        var chosenMount = state.mount
          ? selector.querySelector('[data-m-mount="' + state.mount + '"]')
          : null;
        if (resultLabel) {
          resultLabel.textContent =
            state.meter && chosenMount
              ? (state.meter === 'gas' ? 'Gas' : 'Electric') + ' · ' + (chosenMount.getAttribute('data-label') || '')
              : 'Pick a mounting type to see matching boxes';
        }
        if (resultCta) {
          var url = null;
          if (state.meter && chosenMount) url = chosenMount.getAttribute('data-url-' + state.meter);
          if (!url && state.meter) {
            var meterEl = selector.querySelector('[data-m-meter="' + state.meter + '"]');
            url = meterEl ? meterEl.getAttribute('data-url') : null;
          }
          resultCta.textContent = state.meter && chosenMount ? 'Show Matching Boxes' : 'Browse All Meter Boxes';
          if (url) resultCta.setAttribute('href', url);
        }
      };
      meterOpts.forEach(function (o) {
        o.addEventListener('click', function (e) {
          e.preventDefault();
          state.meter = o.getAttribute('data-m-meter');
          state.mount = null;
          refresh();
        });
      });
      mountOpts.forEach(function (o) {
        o.addEventListener('click', function (e) {
          e.preventDefault();
          if (!state.meter) state.meter = 'gas';
          state.mount = o.getAttribute('data-m-mount');
          refresh();
        });
      });
      refresh();
    });
  };
  initSelectors(document);
  window.mitrasInitSelectors = initSelectors;
})();

/* Mitras additions — spares module + rich-text table wrapping */
(function () {
  'use strict';

  /* Wrap description-area tables so wide tables scroll instead of breaking layout */
  var TABLE_SEL = '.m-tabs .rte table, .m-article .rte table, .m-rte table';
  var wrapTables = function (root) {
    (root || document).querySelectorAll(TABLE_SEL).forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('m-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'm-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  };
  wrapTables(document);
  window.mitrasWrapTables = wrapTables;

  /* Spares & compatible parts: type filter pills + responsive two-row cap */
  var initSpares = function (root) {
    (root || document).querySelectorAll('[data-m-spares]').forEach(function (mod) {
      if (mod.getAttribute('data-m-bound') === '1') return;
      mod.setAttribute('data-m-bound', '1');
      var grid = mod.querySelector('[data-m-spares-grid]');
      var items = Array.prototype.slice.call(mod.querySelectorAll('[data-m-spare]'));
      var pills = Array.prototype.slice.call(mod.querySelectorAll('[data-m-spares-filter]'));
      var moreBtn = mod.querySelector('[data-m-spares-more]');
      var moreWrap = mod.querySelector('[data-m-spares-more-wrap]');
      if (!items.length) return;
      var state = { filter: '', expanded: false };

      /* Same two-row cap the CSS clamp paints before JS runs, so nothing shifts. */
      var capFor = function () {
        if (window.matchMedia('(min-width: 990px)').matches) return 8;
        if (window.matchMedia('(min-width: 750px)').matches) return 6;
        return 4;
      };

      var apply = function () {
        var cap = capFor();
        var shown = 0;
        var matchTotal = 0;
        items.forEach(function (li) {
          var match = !state.filter || li.getAttribute('data-type') === state.filter;
          if (match) matchTotal += 1;
          var visible = match && (state.expanded || shown < cap);
          if (visible) shown += 1;
          li.style.display = visible ? '' : 'none';
        });
        if (moreWrap) moreWrap.style.display = !state.expanded && matchTotal > cap ? '' : 'none';
        if (moreBtn) {
          moreBtn.textContent =
            'Show All ' + matchTotal + ' Compatible Part' + (matchTotal === 1 ? '' : 's');
        }
        pills.forEach(function (p) {
          var on = p.getAttribute('data-m-spares-filter') === state.filter;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      };

      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          state.filter = p.getAttribute('data-m-spares-filter');
          state.expanded = false;
          apply();
        });
      });
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          state.expanded = true;
          apply();
        });
      }

      /* Hand control from the CSS clamp to JS without a repaint gap. */
      if (grid) grid.classList.remove('is-clamped');
      apply();

      var rt;
      window.addEventListener('resize', function () {
        window.clearTimeout(rt);
        rt = window.setTimeout(apply, 150);
      });
    });
  };
  initSpares(document);
  window.mitrasInitSpares = initSpares;
})();

/* Reveal the purchase-panel spares signpost only when this product has spares of its
   own. The band can also be populated from the section's "preview collection" scaffold,
   which is not product-specific — in that case the signpost must stay hidden, otherwise
   every product claims to have compatible parts. */
(function () {
  'use strict';
  var initSignpost = function () {
    var sign = document.querySelector('[data-m-spares-signpost]');
    var mod = document.querySelector('[data-m-spares]');
    if (!sign || !mod) return;
    if (mod.getAttribute('data-m-spares-preview') === 'true') return;
    var n = mod.querySelectorAll('[data-m-spare]').length;
    if (!n) return;
    sign.removeAttribute('hidden');
    var count = sign.querySelector('[data-m-spares-count]');
    if (count && !count.textContent.trim()) {
      count.textContent = n + (n === 1 ? ' compatible part' : ' compatible parts') + ' — view below';
    }
    if (sign.getAttribute('data-m-bound') === '1') return;
    sign.setAttribute('data-m-bound', '1');
    sign.addEventListener('click', function (e) {
      var target = document.getElementById('m-spares');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };
  initSignpost();
  window.mitrasInitSparesSignpost = initSignpost;
})();

/* Theme-editor support: re-initialise Mitras behaviour for a section that Shopify
   has just re-rendered. Scoped to event.target so nothing already bound is bound twice. */
document.addEventListener('shopify:section:load', function (event) {
  var scope = event.target || document;
  if (typeof window.mitrasWrapTables === 'function') window.mitrasWrapTables(scope);
  if (typeof window.mitrasInitTabs === 'function') window.mitrasInitTabs(scope);
  if (typeof window.mitrasInitSpares === 'function') window.mitrasInitSpares(scope);
  if (typeof window.mitrasInitSparesSignpost === 'function') window.mitrasInitSparesSignpost();
  if (typeof window.mitrasInitSelectors === 'function') window.mitrasInitSelectors(scope);
});
